export const FETCH_DIARY_NOTES_LOADING = "FETCH_DIARY_NOTES_LOADING";
export const FETCH_DIARY_NOTES_SUCCESS = "FETCH_DIARY_NOTES_SUCCESS";
export const FETCH_DIARY_NOTES_FAILED = "FETCH_DIARY_NOTES_FAILED";
